export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: '返回',
            backToProject: '返回首頁',
            defaultTitle: '無標題文檔',
            editTitle: '點擊編輯標題',
            clickToEditName: '點擊編輯',
            screen: {
                single: '單屏',
                split: '分屏',
            },
            aiHiro: 'Hiro',
            save: '保存',
            saveOptions: '保存選項',
            saveToFolder: '保存到資料夾',
            saveSuccess: '保存成功',
            saveFailed: '保存失敗',
            export: '導出',
            share: '分享',
            sharePermissionDenied: '只有項目創建者可以分享',
            readOnlyWarning: '權限不足：您只有唯讀權限',
            emptyContentError: '文檔內容為空，無法保存',
            updateTitleSuccess: '標題更新成功',
            updateTitleFailed: '更新標題失敗',
            importing: '正在導入文檔...',
            importSuccess: '導入成功',
            importFailed: '導入失敗',
            exportUpgradeTip: '導出功能僅限付費用戶 ',
            upgradeLink: '立即升級',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: '添加來源',
            createDocument: '創建文檔',
            selectDocumentType: '選擇文檔類型並創建',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: '空白文檔',
            placeholder: '創建空白文檔',
            title: '空白文檔',
            description: '創建一個空白文檔，從頭開始撰寫',
            action: '創建空白文檔',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: '關閉其他',
            closeAll: '關閉所有',
            files: '文件',
            originalText: '原文',
        },
    },
};
